import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { UtilService } from './util-service';

@Injectable()
export class TermoReferenciaAditivoService {

  constructor(private utilService: UtilService) { }


  public listarArquivos(aditivo): Observable<any> {
    let urlObtencaoDados: string = "arquivoAditivo/listar/" + aditivo.idAditivo;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarArquivo(event, aditivo) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "arquivoAditivo/salvar/" + aditivo.idAditivo;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/termo-referencia-aditivo.ts